<template>
  <v-dialog v-model="dialog" width="90%" persistent>
    <v-card>
      <!-- Header Simple y Elegante -->
      <v-card-title>
        <s-toolbar
            label="Orden de venta"
            dark
            color="#8E8F91"
            close
            @close="closeDialog"
            save
            @save="save"
            iconColor="white"
        ></s-toolbar>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Loading State -->
      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
      </v-overlay>

      <!-- Saving State -->
      <v-overlay :value="saving" absolute z-index="10">
        <div class="text-center">
          <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
          <div class="mt-4 text-h6 white--text">Guardando...</div>
        </div>
      </v-overlay>

      <!-- Content -->
      <v-card-text class="pa-0" v-if="!loading">
        <v-form ref="form" v-model="valid">
          <v-row no-gutters align="stretch" style="position: relative;">
            <v-col cols="12" md="9" class="pa-4" style="border-right: 1px solid #e0e0e0;">
              <v-card class="mb-4 pa-4" outlined>
                <v-card-title class="pa-0 text-h6 font-weight-bold">Información del Cliente</v-card-title>
                <v-card-text class="pa-0">
                  <v-row>
                    <v-col cols="12" md="6" class="pr-md-10">
                      <v-row dense>
                        <v-col cols="12" sm="6">
                          <s-text trim-spaces
                            label="Cliente"
                            v-model="saleOrder.CardCode"
                            :rules="[rules.required]"
                            outlined
                            dense
                            hide-details="auto"
                            readonly
                          ></s-text>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <s-text trim-spaces
                            label="Nombre"
                            v-model="saleOrder.CardName"
                            :rules="[rules.required]"
                            outlined
                            dense
                            hide-details="auto"
                            readonly
                          ></s-text>
                        </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col cols="12" sm="6">
                          <s-text trim-spaces
                            label="Persona de contacto"
                            v-model="saleOrder.CntctName"
                            outlined
                            dense
                            hide-details="auto"
                            readonly
                          ></s-text>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <s-text trim-spaces
                            label="Número de referencia del cliente"
                            v-model="saleOrder.NumAtCard"
                            outlined
                            dense
                            hide-details="auto"
                            readonly
                          ></s-text>
                        </v-col>
                      </v-row>

                      <v-row dense class="mt-2">
                        <v-col cols="12" md="6" sm="3">
                          <s-text trim-spaces
                            label="Moneda SN"
                            v-model="saleOrder.DocCur"
                            :rules="[rules.required]"
                            outlined
                            dense
                            hide-details="auto"
                            readonly
                          ></s-text>
                        </v-col>
                        <v-col cols="12" md="6" sm="3">
                          <s-text trim-spaces
                            label="Tipo de cambio"
                            v-model="saleOrder.DocRate"
                            outlined
                            dense
                            hide-details="auto"
                            type="number"
                            readonly
                          ></s-text>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="6" class="pl-md-10">
                      <v-row dense>
                        <v-col cols="12" sm="6">
                          <s-text trim-spaces
                            label="N°"
                            v-model="saleOrder.DocNum"
                            outlined
                            dense
                            hide-details
                            readonly
                          ></s-text>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <s-select
                            label="Estado"
                            v-model="saleOrder.DocStatus"
                            :items="statusOptions"
                            item-text="text"
                            item-value="value"
                            outlined
                            readonly
                          ></s-select>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12" sm="6">
                          <s-date
                            label="Fecha de contabilización"
                            v-model="saleOrder.DocDate"
                            :rules="[rules.required]"
                            outlined
                            dense
                            hide-details
                            disabled
                          ></s-date>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <s-date
                            label="Fecha de entrega"
                            v-model="saleOrder.DocDueDate"
                            outlined
                            dense
                            hide-details
                            disabled
                          ></s-date>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12" sm="6">
                          <s-date
                            label="Fecha del documento"
                            v-model="saleOrder.TaxDate"
                            outlined
                            dense
                            hide-details
                            disabled
                          ></s-date>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Tabs de Contenido -->
              <v-tabs v-model="activeTab" background-color="transparent" color="primary">
                <v-tab>Contenido</v-tab>
              </v-tabs>

              <v-tabs-items v-model="activeTab">
                <!-- Tab Contenido -->
                <v-tab-item>
                  <div class="mt-4">
                    <v-data-table
                      :headers="itemHeaders"
                      :items="saleOrder.ExtSaleOrderDetails || []"
                      dense
                      hide-default-footer
                      class="elevation-1"
                    >
                      <template v-slot:top>
                        <v-toolbar flat dense color="grey lighten-4">
                          <span class="text-caption">Clase de artículo/servicio: {{ saleOrder.DocTypeName }}</span>
                          <v-spacer></v-spacer>
                          <s-text trim-spaces
                            label="Clase de resumen"
                            v-model="saleOrder.SummryTypeName"
                            outlined
                            dense
                            hide-details
                            disabled
                          ></s-text>
                        </v-toolbar>
                      </template>
                    </v-data-table>
                  </div>
                </v-tab-item>
              </v-tabs-items>

              <v-divider class="my-4"></v-divider>

              <!-- Información Adicional Inferior -->
              <v-row dense>
                <v-col cols="12" sm="6">
                 <s-text trim-spaces
                    label="Empleado de ventas"
                    v-model="saleOrder.SlpName"
                    outlined
                    dense
                    hide-details="auto"
                    readonly
                  ></s-text>
                </v-col>
                <v-col cols="12" sm="6">
                  <s-text trim-spaces
                    label="Propietario"
                    v-model="saleOrder.OwnerFullName"
                    outlined
                    dense
                    hide-details="auto"
                    readonly
                  ></s-text>
                </v-col>
              </v-row>

              <v-row dense class="mt-2">
                <v-col cols="12">
                  <s-textarea
                    label="Comentarios"
                    v-model="saleOrder.Comments"
                    outlined
                    dense
                    hide-details="auto"
                    readonly
                  ></s-textarea>
                </v-col>
              </v-row>

              <!-- Totales -->
              <v-row dense class="mt-4">
                <v-col cols="12" class="text-right">
                  <div class="d-flex justify-end align-center mb-1">
                    <span class="text-body-2 mr-4">Total antes del descuento:</span>
                    <span class="font-weight-medium">{{ formatCurrency(saleOrder.DocTotalAC) }}</span>
                  </div>
                  <div class="d-flex justify-end align-center mb-1">
                    <span class="text-body-2 mr-4">Descuento:</span>
                    <span class="font-weight-medium">{{ formatCurrency(0) }}</span>
                  </div>
                  <div class="d-flex justify-end align-center mb-1">
                    <span class="text-body-2 mr-4">Gastos adicionales:</span>
                    <span class="font-weight-medium">{{ formatCurrency(saleOrder.TotalExpFC || 0) }}</span>
                  </div>
                  <div class="d-flex justify-end align-center mb-1">
                    <span class="text-body-2 mr-4">Impuesto:</span>
                    <span class="font-weight-medium">{{ formatCurrency(0) }}</span>
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div class="d-flex justify-end align-center">
                    <span class="text-h6 mr-4">Total del documento:</span>
                    <span class="text-h6 font-weight-bold primary--text">{{ formatCurrency(saleOrder.DocTotalFC) }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-col>

            <!-- Panel Lateral Derecho -->
            <v-col cols="12" md="3" class="pa-0 grey lighten-5 right-panel-container">
                <div class="right-panel-scroll pa-4">
                    <div class="mb-4">
                        <s-select
                          v-model="selectedGuideType"
                          :items="guideTypes"
                          item-text="text"
                          item-value="value"
                          outlined
                          dense
                          hide-details
                        ></s-select>
                    </div>
                    
                    <v-divider class="mb-4"></v-divider>
                    
                    <div v-if="selectedGuideType === 'GUIA_1'">
                      <div class="mb-2">
                          <s-select
                            label="Motivo de Traslado"
                            v-model="saleOrder.U_SYP_MDMT"
                            :items="transferReasons"
                            outlined
                            dense
                            hide-details
                            clearable
                          ></s-select>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Nro. de Guia de Entrega"
                            v-model="saleOrder.U_SYP_NGUIA"
                            outlined
                            dense
                            hide-details
                            :search-icon="true"
                            @click:append="generateGuiaNumber"
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-date
                            label="Fecha de Embarque"
                            v-model="saleOrder.U_SYP_MDFE"
                            outlined
                            dense
                            hide-details
                          ></s-date>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Precinto Naviera"
                            v-model="saleOrder.U_SYP_PNAVIERA"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-select
                            label="O. Logistico"
                            v-model="saleOrder.U_SYP_OL"
                            :items="logisticsList"
                            outlined
                            dense
                            hide-details
                            clearable
                          ></s-select>
                      </div>
                      <div class="mb-2">
                          <s-date
                            label="Fecha ETA"
                            v-model="saleOrder.U_SYP_ETA"
                            outlined
                            dense
                            hide-details
                          ></s-date>
                      </div>
                      <div class="mb-2">
                          <s-select
                            label="Campaña"
                            v-model="saleOrder.U_SYP_CAMPANA"
                            :items="campaigns"
                            item-text="text"
                            item-value="value"
                            outlined
                            dense
                            hide-details
                            clearable
                          ></s-select>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Contenedor No."
                            v-model="saleOrder.U_SYP_CONTENEDOR"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-select
                            label="Area Produccion"
                            v-model="saleOrder.U_SYP_AREAPROD"
                            :items="areaProduct"
                            outlined
                            dense
                            hide-details
                            clearable
                          ></s-select>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Detalle de Cantidad por Caja"
                            v-model="saleOrder.U_SYP_DETQTYCAJA"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Embarque/Despacho N°"
                            v-model="saleOrder.U_SYP_EMBARQUE"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Booking No."
                            v-model="saleOrder.U_SYP_BOOKING"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-select
                            label="Naviera / Aerolínea"
                            v-model="saleOrder.U_SYP_NAVIERA"
                            :items="navieras"
                            outlined
                            dense
                            hide-details
                            clearable
                          ></s-select>
                      </div>
                      <div class="mb-2">
                          <s-search-modal
                            label="Nave / Vuelo"
                            v-model="saleOrder.U_SYP_NAVE"
                            list-code="U_SYP_NAVE"
                            :headers="headersNaviera"
                          ></s-search-modal>
                      </div>
                      <div class="mb-2">
                          <s-select
                            label="Temperatura B/L"
                            v-model="saleOrder.U_SYP_TEMPBL"
                            :items="tempbl"
                            outlined
                            dense
                            hide-details
                            clearable
                          ></s-select>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Viaje salida No."
                            v-model="saleOrder.U_SYP_VIAJE"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-search-modal
                            label="Comentarios"
                            v-model="saleOrder.U_SYP_COMENTARIOS"
                            list-code="U_SYP_COMENTARIOS"
                            :headers="headersComments"
                          ></s-search-modal>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Cliente/Proveedor"
                            v-model="saleOrder.U_SYP_CLIENTE"
                            :search-icon="true"
                            outlined
                            dense
                            hide-details
                            @click:append="copyCardNameToCliente"
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="D.A.M."
                            v-model="saleOrder.U_SYP_DUA"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-select
                            label="Cod. Certificación"
                            v-model="saleOrder.U_SYP_COD_CERT"
                            :items="codCert"
                            outlined
                            dense
                            hide-details
                            clearable
                          ></s-select>
                      </div>
                      <div class="mb-2">
                          <s-select
                            label="Puerto de Embarque"
                            v-model="saleOrder.U_SYP_PTOEMBARQUE"
                            :items="ptosEmbarque"
                            outlined
                            dense
                            hide-details
                            clearable
                          ></s-select>
                      </div>
                      <div class="mb-2">
                          <s-search-modal
                            label="Puerto Destino"
                            v-model="saleOrder.U_SYP_PTODESTINO"
                            list-code="U_SYP_PTODESTINO"
                            :headers="headersPtoDestino"
                            :extra-param="saleOrder.CardCode"
                          ></s-search-modal>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Sticker"
                            v-model="saleOrder.U_SYP_NROSOLDRAW"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Cable"
                            v-model="saleOrder.U_SYP_NRORECHAZO"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Precinto  Aduanas"
                            v-model="saleOrder.U_SYP_PADUANAS"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Precinto Botella"
                            v-model="saleOrder.U_SYP_PSUNSHINE"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Precinto Senasa o APHIS"
                            v-model="saleOrder.U_SYP_PSENASA"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="N° PP"
                            v-model="saleOrder.U_SYP_PAPHIS"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            decimal
                            label="Peso Neto"
                            v-model="saleOrder.U_SYP_PNETO"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            decimal
                            label="Peso Bruto"
                            v-model="saleOrder.U_SYP_PBRUTO"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Pallet 1"
                            v-model="saleOrder.U_SUN_PALLET1"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Pallet 2"
                            v-model="saleOrder.U_SUN_PALLET2"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Termoregistro 1"
                            v-model="saleOrder.U_SUN_TERMO1"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Termoregistro 2"
                            v-model="saleOrder.U_SUN_TERMO2"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-date
                            label="Fecha de guía"
                            v-model="saleOrder.U_SYP_FGUIA"
                            outlined
                            dense
                            hide-details
                          ></s-date>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            decimal
                            label="Total de cajas"
                            v-model="saleOrder.U_SYP_TCAJAS"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Tiempo de transito"
                            v-model="saleOrder.U_SUN_TIEMPOTRANSITO"
                            :search-icon="true"
                            outlined
                            dense
                            hide-details
                            @click:append="calculateETA"
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="N° Pedido IQF"
                            v-model="saleOrder.U_SYP_NPEDIDO"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-select
                            label="Humedad (%)"
                            v-model="saleOrder.U_SUN_HUMIDITY"
                            :items="humidity"
                            outlined
                            dense
                            hide-details
                            clearable
                          ></s-select>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Ventilación (CBM/CBH)"
                            v-model="saleOrder.U_SUN_VENTILATION"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-select
                            label="Atmosfera Controlada "
                            v-model="saleOrder.U_SUN_ATMOSPHERE"
                            :items="atmosphere"
                            outlined
                            dense
                            hide-details
                            clearable
                          ></s-select>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Oxigeno (%02)"
                            v-model="saleOrder.U_SUN_OXYGEN"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Dióxido de Carbono"
                            v-model="saleOrder.U_SUN_DIOXIDE"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Marca Termorregistro"
                            v-model="saleOrder.U_SUN_BRAND"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-select
                            label="Planta Procesadora"
                            v-model="saleOrder.U_SUN_PLAPROCESADORA"
                            :items="plantProcess"
                            outlined
                            dense
                            hide-details
                            clearable
                          ></s-select>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Otros Precintos"
                            v-model="saleOrder.U_SUN_POTHERS"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Cod. Kit Seguridad"
                            v-model="saleOrder.U_SUN_SAFETY_KIT"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Constancia MTC Carreta"
                            v-model="saleOrder.U_SUN_CERTIFICATE_MTC"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="N° de Registro MTC"
                            v-model="saleOrder.U_SUN_REGISTRATION_MTC"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                    </div>
                    
                    <div v-if="selectedGuideType === 'GUIA_2'">
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="RUC del Transportista"
                            v-model="saleOrder.U_SYP_MDRT"
                            :search-icon="true"
                            outlined
                            dense
                            hide-details
                            @click:append="fetchLinkedData('U_SYP_MDRT', 'U_SYP_MDNT', 'Transportista')"
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-search-modal
                            label="Nombre del Transportista"
                            v-model="saleOrder.U_SYP_MDNT"
                            list-code="U_SYP_MDNT"
                            :headers="headersMDNT"
                            @change="onCarrierNameChange"
                          ></s-search-modal>
                      </div>
                      <div class="mb-2">
                          <s-search-modal
                            label="Nombre del Conductor"
                            v-model="saleOrder.U_SYP_MDFN"
                            list-code="U_SYP_MDFN"
                            :headers="headersMDFN"
                            @change="onDriverNameChange"
                          ></s-search-modal>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Licencia del Conductor"
                            v-model="saleOrder.U_SYP_MDFC"
                            :search-icon="true"
                            outlined
                            dense
                            hide-details
                            @click:append="fetchLinkedData('U_SYP_MDFC', 'U_SYP_MDFN', 'Conductor')"
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-search-modal
                            label="Marca del Vehiculo"
                            v-model="saleOrder.U_SYP_MDVN"
                            list-code="U_SYP_MDVN"
                            :headers="headersMDVN"
                          ></s-search-modal>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Placa de Vehiculo"
                            v-model="saleOrder.U_SYP_MDVC"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Placa de Tolva"
                            v-model="saleOrder.U_SYP_MDVT"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-search-modal
                            label="Almacen de Destino"
                            v-model="saleOrder.U_SYP_ALMOL"
                            list-code="U_SYP_ALMOL"
                            :headers="headersALMOL"
                            @change="onAlmacenDestinyChange"
                          ></s-search-modal>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Dirección Almacen de Destino"
                            v-model="saleOrder.U_SYP_DIROL"
                            outlined
                            dense
                            hide-details
                            :search-icon="true"
                            @click:append="fetchLinkedData('U_SYP_DIROL', 'U_SYP_ALMOL', 'Almacen de Destino')"
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="RUC Almacén de Destino"
                            v-model="saleOrder.U_SYP_RUCOL"
                            outlined
                            dense
                            hide-details
                            :search-icon="true"
                            @click:append="fetchLinkedData('U_SYP_RUCOL', 'U_SYP_ALMOL', 'Almacen de Destino')"
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Constancia de Inscripción N°"
                            v-model="saleOrder.U_SYP_Constancia"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-search-modal
                            label="Dirección de Despacho"
                            v-model="saleOrder.U_SUN_DIRDESPACHO"
                            list-code="U_SUN_DIRDESPACHO"
                            :headers="headersDirDespacho"
                          ></s-search-modal>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Nombre del Chofer"
                            v-model="saleOrder.U_SUN_NAME_DRIVER"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Apellido del Chofer"
                            v-model="saleOrder.U_SUN_LASTNAME_DRIVER"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                      <div class="mb-2">
                          <s-search-modal
                            label="Punto de partida (Ubigeo)"
                            v-model="saleOrder.U_SUN_PTOP_U"
                            list-code="U_SUN_PTOP_U"
                            :headers="headersPtoDeparture"
                          ></s-search-modal>
                      </div>
                      <div class="mb-2">
                          <s-search-modal
                            label="Punto de llegada (Ubigeo)"
                            v-model="saleOrder.U_SUN_PTOLL_U"
                            list-code="U_SUN_PTOP_U"
                            :headers="headersPtoDeparture"
                          ></s-search-modal>
                      </div>
                      <div class="mb-2">
                          <s-text trim-spaces
                            label="Codigo de Establecimiento"
                            v-model="saleOrder.U_SUN_CODEST"
                            outlined
                            dense
                            hide-details
                          ></s-text>
                      </div>
                    </div>
                </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
import _sSaleOrder from "@/services/ExternalTrade/SaleOrderService.js";

export default {
  name: "SaleOrderEdit",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    docEntry: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      ussUserCode: null,
      dialog: false,
      loading: false,
      saving: false,
      valid: false,
      activeTab: 0,
      summaryType: 'Sin resumen',
      selectedGuideType: 'GUIA_1',
      guideTypes: [
        { text: 'GUIA DE REMISION', value: 'GUIA_1' },
        { text: 'GUIA DE REMISION II', value: 'GUIA_2' }
      ],
      saleOrder: {
        DocEntry: null,
        DocNum: null,
        DocDate: null,
        DocDueDate: null,
        TaxDate: null,
        CardCode: null,
        CardName: null,
        CntctName: null,
        NumAtCard: null,
        DocCur: 'US$',
        DocRate: 3.3740,
        DocTotal: null,
        VatSum: null,
        Comments: null,
        DocStatus: 'O',
        SalesPersonCode: null,
        Owner: null,
        DocumentLines: [],
        // Campos del panel derecho
        TransferReason: 'EXPORTACIÓN',
        DocType: null,
        Series: null,
        SequenceCode: null,
        DocumentStatus: 'Vigente',
        DeliveryGuideNumber: null,
        CustomerOrderNumber: null,
        AdvanceNumber: null,
        PurchaseType: 'No Asignado',
        Advance: 'Ninguno',
        AdvancePercent: 0.000,
        SupplierQuoteNumber: null,
        ImportNumber: null,
        DetractionDepositDate: null,
        DetractionDepositNumber: null,
        ShipDate: null,
        DUANumber: null,
        CustomsCode: null,
        DUADate: null,
        CCERNumber: null,
        RequirementType: 'No Asignado',
        TicketType: null,
        ShipmentType: null,
        RetentionVoucherNumber: null,
        CarrierCode: null,
        CarrierRUC: null,
        CarrierName: null,
        ShipToCode: null,
        DriverName: null,
        DriverLicense: null,
        VehicleBrand: null,
        VehiclePlate: null,
        PaymentTerms: null
      },
      itemHeaders: [
        { text: 'Número de artículo', value: 'ItemCode' },
        { text: 'Número de catálogo TC', value: 'SubCatNum' },
        { text: 'Descripción del artículo', value: 'Dscription' },
        { text: 'Cantidad', value: 'Quantity'},
        { text: 'Precio por unidad', value: 'Price'},
        { text: '% de descuento', value: 'DiscPrcnt'},
        { text: 'Indicador de impuestos', value: 'TaxCode'},
        { text: 'Impuesto %', value: 'VatPrcnt'},
        { text: 'Código de unidad de medida', value: 'UomCode'},
        { text: 'Descripcion Adicional', value: 'U_SYP_FEDA'},
        { text: 'Total (doc.)', value: 'TotalFrgn'}
      ],
      statusOptions: [
        { text: 'Abierto', value: 'O', color: 'success' },
        { text: 'Cerrado', value: 'C', color: 'error' },
        { text: 'Cancelado', value: 'X', color: 'grey' }
      ],
      transferReasons: [],
      salesPersons: [
        { text: 'Ningún empleado del depart.', value: null }
      ],
      rules: {
        required: value => !!value || 'Este campo es requerido'
      },
      logisticsList: [],
      campaigns: [],
      areaProduct: [],
      navieras: [],
      tempbl: [],
      codCert: [],
      ptosEmbarque: [],
      humidity: [],
      atmosphere: [],
      plantProcess: [],
      headersPtoDestino: [
        { text: 'Destino', value: 'value' }
      ],
      headersPtoDeparture: [
        { text: 'Código', value: 'value' },
        { text: 'Distrito', value: 'text' },
        { text: 'Provincia', value: 'selected' },
        { text: 'Departamento', value: 'extraParam' }
      ],
      headersMDNT: [
        { text: 'Nombre Transportista', value: 'value' }
      ],
      headersMDFN: [
        { text: 'Nombre Conductor', value: 'value' },
        { text: 'Licencia', value: 'text' }
      ],
      headersMDVN: [
        { text: 'Marca', value: 'value' }
      ],
      headersALMOL: [
        { text: 'Almacen de Destino', value: 'value' }
      ],
      headersNaviera: [
        { text: 'Naviera / Aerolínea', value: 'value' }
      ],
      headersComments: [
        { text: 'Comentarios', value: 'value' }
      ],
      headersDirDespacho: [
        { text: 'Dirección de Despacho', value: 'value' },
      ],
    };
  },
  watch: {
    value(newVal) {
      this.dialog = newVal;
      if (newVal && this.docEntry) {
        this.loading = true;
        this.loadSaleOrder();
        this.initializeData();
        this.loading = false;
      }
    },
    dialog(newVal) {
      if (!newVal) {
        this.$emit('input', false);
      }
    }
  },
  methods: {
    async fetchLinkedData(targetField, sourceField, fieldNameDesc, sourceValueOpt = null) {
      const nameSearch = sourceValueOpt || this.saleOrder[sourceField];
      if (!nameSearch) {
        this.$fun.alert(`Seleccione o ingrese primero el Nombre del ${fieldNameDesc}.`, "warning");
        return;
      }
      this.loading = true;
      try {
        const payload = {
          selected: targetField,
          extraParam: nameSearch
        };
        const response = await _sSaleOrder.list_modal_search(payload, this.$fun.getUserID());
        if (response.status === 200 && response.data && response.data.length > 0) {
          this.saleOrder[targetField] = response.data[0].value;
          if (response.data[0].extraParam) {
            this.saleOrder[sourceField] = response.data[0].extraParam;
          }
        } else {
          this.$fun.alert(`No se encontraron datos de ${fieldNameDesc}.`, "warning");
        }
      } catch (error) {
        console.error(error);
        this.$fun.alert(`Error buscando datos del ${fieldNameDesc}`, "error");
      } finally {
        this.loading = false;
      }
    },
    async onCarrierNameChange(item) {
      if (item && item.value) {
        this.fetchLinkedData('U_SYP_MDRT', 'U_SYP_MDNT', 'Transportista', item.value);
      }
    },
    async onDriverNameChange(item) {
      if (item && item.value) {
        this.fetchLinkedData('U_SYP_MDFC', 'U_SYP_MDFN', 'Conductor', item.value);
      }
    },
    async onAlmacenDestinyChange(item) {
      if (item && item.value) {
        this.fetchLinkedData('U_SYP_DIROL', 'U_SYP_ALMOL', 'Almacen de Destino', item.value);
        this.fetchLinkedData('U_SYP_RUCOL', 'U_SYP_ALMOL', 'Almacen de Destino', item.value);
      }
    },
    copyCardNameToCliente() {
      if (this.saleOrder.CardName) {
        this.saleOrder.U_SYP_CLIENTE = this.saleOrder.CardName;
      } else {
        this.$fun.alert("El nombre del cliente (CardName) está vacío.", "warning");
      }
    },
    calculateETA() {
      const transitDays = parseInt(this.saleOrder.U_SUN_TIEMPOTRANSITO);
      if (isNaN(transitDays)) {
        this.$fun.alert("Ingrese un número de días válido para el Tiempo de Tránsito.", "warning");
        return;
      }

      if (!this.saleOrder.U_SYP_MDFE) {
        this.$fun.alert("Seleccione primero la Fecha de Embarque para poder calcular la Fecha ETA.", "warning");
        return;
      }

      let embarqueStr = this.saleOrder.U_SYP_MDFE;
      if (embarqueStr.indexOf('T') === -1) {
          embarqueStr += 'T00:00:00';
      }

      const embarqueDate = new Date(embarqueStr);
      embarqueDate.setDate(embarqueDate.getDate() + transitDays);

      const yy = embarqueDate.getFullYear();
      const mm = String(embarqueDate.getMonth() + 1).padStart(2, '0');
      const dd = String(embarqueDate.getDate()).padStart(2, '0');
      
      this.saleOrder.U_SYP_ETA = `${yy}-${mm}-${dd}`;
    },
    async generateGuiaNumber() {
      if (!this.saleOrder.DocEntry) {
        this.$fun.alert('No hay una Orden de Venta seleccionada.', 'warning');
        return;
      }
      this.loading = true;
      try {
        const response = await _sSaleOrder.getguianumber(
          { DocEntry: this.saleOrder.DocEntry },
          this.$fun.getUserID()
        );
        if (response && response.status === 200 && response.data) {
          this.saleOrder.U_SYP_NGUIA = response.data;
          this.$fun.alert(
            `Número de guía obtenido: ${response.data}`,
            'success'
          );
        } else {
          this.$fun.alert(
            'No se encontró una guía de remisión asociada a esta Orden de Venta.',
            'warning'
          );
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async initializeData() {
      await this.loadSaleOrder();
      await this.loadSelected('U_SYP_MDMT', 'transferReasons');
      await this.loadSelected('U_SYP_OL', 'logisticsList');
      await this.loadSelected('U_SYP_CAMPANA', 'campaigns');
      await this.loadSelected('U_SYP_AREAPROD', 'areaProduct');
      await this.loadSelected('U_SYP_NAVIERA', 'navieras');
      await this.loadSelected('U_SYP_TEMPBL', 'tempbl');
      await this.loadSelected('U_SYP_COD_CERT', 'codCert');
      await this.loadSelected('U_SYP_PTOEMBARQUE', 'ptosEmbarque');
      await this.loadSelected('U_SUN_HUMIDITY', 'humidity');
      await this.loadSelected('U_SUN_ATMOSPHERE', 'atmosphere');
      await this.loadSelected('U_SUN_PLAPROCESADORA', 'plantProcess');
    },
    async loadSelected(selectedField, targetProperty) {
      try {
        const response = await _sSaleOrder.list_selected(
          { selected: selectedField },
          this.$fun.getUserID()
        );
        if (response.status === 200 && response.data) {
          // console.log(`response.data ${selectedField}:`, response.data);
          this[targetProperty] = response.data;
        }
      } catch (error) {
        console.error(`Error al cargar ${selectedField}:`, error);
      }
    },
    async loadSaleOrder() {
      try {
        this.saleOrder = {};
        // console.log("this.docEntry", this.docEntry);
        const response = await _sSaleOrder.ordersalesbydocentry(
          { DocEntry: this.docEntry },
          this.$fun.getUserID()
        );
        
        if (response.status === 200 && response.data) {
          // console.log("response.data", response.data);
          this.saleOrder = {
            ...response.data,
            DocDate: response.data.DocDate || null,
            DocDueDate: response.data.DocDueDate || null
          };
        }
      } catch (error) {
        this.closeDialog();
      }
    },
    
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      console.log("this.saleOrder", this.saleOrder);
      if(!this.saleOrder.DocEntry) {
        this.$fun.alert('Seleccione una orden de venta', 'warning');
        return;
      }
      // console.log("this.saleOrder", this.saleOrder);
      const result = await this.$fun.alert("¿Desea Guardar la Orden de Venta?", "question");
      if (!result.value) {
        return;
      }

      this.ussUserCode = this.$fun.getUserSAPInfo().UssUserCode;

      if (this.ussUserCode == null) {
          this.$fun.alert(
              "No tiene un Usuario SAP autenticado, Comuniquese con el Área de TECNOLOGÍA DE LA INFORMACIÓN..",
              "warning",
          );
          return;
      }

      this.saving = true;
      try {
        const response = await _sSaleOrder.save(
          this.saleOrder,
          this.$fun.getUserID()
        );
        
        if (response.status === 200) {
          this.$fun.alert('Orden de venta actualizada correctamente', 'success');
          this.$emit('saved', this.saleOrder);
          this.closeDialog();
        }
      } catch (error) {
        console.error('Error saving sale order:', error);
      } finally {
        this.saving = false;
      }
    },
    
    closeDialog() {
      this.dialog = false;
      this.$emit('input', false);
      this.$emit('close');
    },

    formatCurrency(value) {
      if (!value) return `${this.saleOrder.DocCur || 'US$'} 0.00`;
      return `${this.saleOrder.DocCur || 'US$'} ${parseFloat(value).toLocaleString('en-US', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      })}`;
    }
  }
};
</script>

<style scoped>
.right-panel-container {
  position: relative;
  height: 100%;
}

.right-panel-scroll {
  overflow-y: auto;
  overflow-x: hidden;
}

@media (min-width: 960px) {
  .right-panel-container {
    position: static; /* Let the scroll child position relative to the Row */
  }

  .right-panel-scroll {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 25%; /* Equivale a md="3" (3/12) */
    background: #FAFAFA; /* Coincide con grey lighten-5 */
    border-left: 1px solid #e0e0e0; /* Opcional: separador visual */
    z-index: 1;
  }
}

/* Personalizar scrollbar */
.right-panel-scroll::-webkit-scrollbar {
  width: 8px;
}

.right-panel-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.right-panel-scroll::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.right-panel-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>